import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
    Milestone,
    IMilestoneEvents,
    IPosition,
    IMilestoneReOrder,
    IChangedData,
} from '../interfaces/milestone';

@Injectable({
    providedIn: 'root',
})
export class MilestoneService {
    constructor(private _http: HttpClient) {}

    private serverUrl = 'https://' + window.location.host;
    private version = '0.5'; // TODO Get version dynamically
    private _url = (this.serverUrl + '/api/v{version}/milestone').replace(
        '{version}',
        this.version
    );
    private _doUrl = (this.serverUrl + '/api/v{version}/displayoption').replace(
        '{version}',
        this.version
    );

    getMilestonesByModule(module: string): Observable<Milestone[]> {
        //TO-DO: make below link api/... dynamic
        return this._http.get<Milestone[]>(
            'https://' + window.location.host + '/api/v0.5/milestone/' + module
        );
    }

    getMilestoneModelsByClient(): Observable<IMilestoneEvents[]> {
        return this._http.get<IMilestoneEvents[]>(this._url + '/GetMilestoneModelsByClient');
    }

    getPositionsByClient(): Observable<IPosition[]> {
        return this._http.get<IPosition[]>(this._url + '/GetPositionsByClient');
    }

    updateMilestone(
        updateColumn: string,
        milestoneChangedData: IChangedData[]
    ): Observable<number> {
        const params = new HttpParams()
            .set('updateColumn', updateColumn)
            .set('milestoneChangedData', JSON.stringify(milestoneChangedData));
        return this._http.get<number>(this._url + '/UpdateMilestone', {
            params: params,
        });
    }

    saveOrdering(milestoneReOrder: IMilestoneReOrder[]): Observable<number> {
        const params = new HttpParams().set('milestoneReOrder', JSON.stringify(milestoneReOrder));
        return this._http.get<number>(this._url + '/SaveOrdering', {
            params: params,
        });
    }
}
